<cst-folder-document-tree
  (dataSourceInit)="onDataSourceInit($event)"
  folderSource="receipt"
  documentSource="infoportal"
/>
